import { get, post } from "../util/paymentConfig";
import { testGet, testPost } from "../util/testPaymentConfig";

//查询H5订单支付信息
export const queryPayInfo = params => get("AgentH5/queryPayInfo", params)
//获取微信支付code
export const getWxCodeData = params => post("AgentH5/getWxCodeData", params)
//获取微信支付OpenId
export const getOpenIdUrl = params => get("AgentH5/getOpenIdUrl", params)
//初始化支付信息
export const initPayment = params => post("AgentH5/initPayment", params)
//获取支付结果
export const getPayResult = params => get("AgentH5/getPayResult", params)
//手动录入流水
export const addOrderSerial = params => post("MiniProgram/addOrderSerial", params)
//查询客户信息
export const queryPayCustomInfo = params => post("MiniProgram/queryPayCustomInfo", params)
//查询公司账户信息
export const queryCompanyPayInfo = params => get("MiniProgram/queryCompanyPayInfo", params)
//定金支付
export const depositPay = params => post("MiniProgram/depositPay", params)
//公校锁定/订单支付流水生成回调
export const SchoolLockOrderSerialCallback = params => post("SchoolLock/SchoolLockOrderSerialCallback", params)

// 支付宝支付
export const useAlipay = params => testPost("api/v1/pay/init", params)






